import { z } from "zod";
import { UIElementType } from "../../../../AppConstants";
import { t } from "i18next";

const getPezodeProductSchema = (lookUpData, existingProducts) => {
    return z.object({
        ConsumableProduct: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Product Name is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createProducts.productName"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.consumableProductList ? lookUpData.consumableProductList : []
                })
            ),
        ProductPerDevice: z
            .number()
            .positive()
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("createProducts.productPerDevice"), isRequired: true }))

    }).superRefine((data, ctx) => {
        const productId = data.ConsumableProduct.id;

        // Check if product is selected
        if (productId !== null) {
            // Check if the selected product is already added
            let _result = false;
            if (existingProducts?.length > 0) {
                _result = existingProducts.some(product => product.ConsumableProduct.id === productId);
            }
            if (_result) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "The selected product already exists.",
                    path: ["ConsumableProduct"],
                });
            }
        }
    });
};

const getPezodeProductDefaultValue = (value = null) => {
    return {
        ConsumableProduct: value ? value?.ConsumableProduct : null,
        ProductPerDevice: value ? value?.ProductPerDevice : null,
        PezodeProductMapId: value ? value?.PezodeProductMapId : null,
    };
};

export { getPezodeProductSchema, getPezodeProductDefaultValue };
